// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.vcard[data-v-dd10f284] {\n  padding: 10px;\n  display: flex;\n  width: 100%;\n}\n", ""]);
// Exports
module.exports = exports;
